import React from "react";
import { useHistory } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, InputGroup, InputGroupAddon, FormFeedback, Input, Button } from "reactstrap";
import { isEmpty } from "lodash";
import { getSim } from "../../api/simcards";
import { getTenant } from "../../api/tenants";
import { getVehicleByPlate } from "../../api/vehicles";
import { getDeviceByImeiEnd } from "../../api/devices";
import { getDeviceByTicket } from "../../api/devices";
import { getDeviceByPlate } from "../../api/devices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createTicket } from "../../api/tickets";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import PageLayout from "../../components/PageLayout";
import moment from "moment";

const StartTicket = () => {
    const [ticket, setTicket] = React.useState({});
    const [plateLabel, setPlateLabel] = React.useState();
    const [errors, setErrors] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const { onSuccess, onError } = useAuth0();
    const [focused, setFocused] = React.useState("plateScanBox");
    const { push } = useHistory()

    React.useEffect(() => {
        //console.log(focused);
        if (focused !== "-") {
            document.getElementById(focused).focus();
        }
    }, [focused]);

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const modalSection = () => (
        <Modal zIndex={2000} centered isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Forzatura inserimento Ticket {openModal}
            </ModalHeader>
            <ModalBody>
                <p>Confermi di voler forzare l'inserimento del nuovo Ticket sul veicolo con targa {openModal}?</p>
                <p>Nell'inserimento del nuovo Ticket sarà comunque necessario procedere con il riconoscimento del Cliente tramite le sue generalità o il numero di telefono visibile nella scheda Cliente.</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="danger" className="ml-auto" onClick={() => forceTicket()}>Forza</Button>
            </ModalFooter>
        </Modal>
    );

    const updateTicket = async (key, value) => {
        const newTicket = {
            ...ticket,
            [key]: value
        };

        setTicket(newTicket);
        await validate(newTicket);
    };

    const getTenantandSimForDevice = async (dev) => {
        if (!dev.tenant_id || !dev.sim_id) return {
            number: " - ",
            tenant: {
                name: " - "
            }
        }
        const data = await Promise.all([
            getTenant(dev.tenant_id),
            getSim(dev.sim_id)
        ]);

        return {
            number: data[1].number,
            tenant: data[0]
        }
    }

    const getDevice = async () => {
        const plate = document.getElementById("plateScanBox").value;
        const ticket = document.getElementById("deviceScanBox").value;
        if (!plate || !ticket) {
            validate({});
            return;
        }
        try {
            setLoading(true);
            const dev = await getDeviceByPlate(plate);
            if (!dev) {
                updateTicket("device", undefined);
            };

            const data = await getTenantandSimForDevice(dev);
            updateTicket("device", {
                ...dev,
                ...data
            });
        } finally {
            setLoading(false);
        }
    };

    const getVehicle = async () => {
        const plate = document.getElementById("plateScanBox").value;
        if (!plate) return;
        try {
            setLoading(true);
            const veichResp = await getVehicleByPlate(plate);
            if (!veichResp) {
                updateTicket("vehicle", undefined);
            };

            updateTicket("vehicle", veichResp);
        } finally {
            setPlateLabel(plate);
            setLoading(false);
        }
    };

    const resetForm = () => {
        setTicket({});
        setErrors({});
        setFocused("-");
        setLoading(false);
        document.getElementById("plateScanBox").value = "";
        document.getElementById("deviceScanBox").value = "";
    };

    const validate = async tkt => {
        let valErrors = {};
        if (!tkt.vehicle) {
            valErrors.vehicle = `Inserire la targa del veicolo o veicolo non trovato`;
        }

        if (!tkt.device || !tkt.device.ticket) {
            valErrors.device = `Inserire il Codice Centrale Operativa o Codice non trovato`;
        }

        if (
            tkt.device &&
            tkt.vehicle &&
            tkt.vehicle.device_id !== tkt.device._id
        ) {
            valErrors.vehicle = `Codice Centrale Operativa non associato a questo veicolo o ticket non effettuabile per mancanza di collaudo!`;
        }

        setErrors(valErrors);
        return isEmpty(valErrors);
    };

    const onScanDevice = e => {
        if (e.key === "Enter") {
            getDevice();
        }
    };

    const onScanPlate = e => {
        if (e.key === "Enter") {
            getVehicle();
        }
    };

    const isValid = () => {
        return isEmpty(errors);
    };

    const forceTicket = () => {
        toggle();
        document.getElementById("deviceScanBox").value = ticket.vehicle.customer_ticket;
        getDevice();
    };

    const saveData = async () => {
        try {
            const isValid = await validate(ticket);
            const textForced = !plateLabel ? 'Ticket inserito' : 'Ticket con inserimento forzato senza Codice Centrale Operativa: effettuare il riconoscimento tramite verifica del nominativo o del telefono.';
            if (!isValid) return;
            setLoading(true);
            const newTicket = await createTicket({
                attributes: {
                    device_id: ticket.device._id,
                    customer_id: ticket.vehicle.customer_id,
                    vehicle_id: ticket.vehicle._id,
                    tenant_id: ticket.device.tenant_id,
                    sim_id: ticket.device.sim_id,
                    tenant_name: ticket.vehicle.tenant_name,
                    customer_name: ticket.vehicle.customer_name,
                    customer_ticket: ticket.vehicle.customer_ticket,
                    plate: ticket.vehicle.plate,
                    frame: ticket.vehicle.frame,
                    imei: ticket.device.imei,
                    ticket: ticket.device.ticket,
                    serial: ticket.device.serial,
                    number: ticket.device.number
                },
                notes: {
                    list: [{
                        text: textForced,
                        time: moment().utc()
                    }]
                }
            });
            onSuccess();
            push(`/centrale/work-ticket/${newTicket._id}`)
        } catch (error) {
            onError();
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageLayout
            title="NUOVO TICKET"
            optionalNav={{ link: "/centrale/tickets", text: "Elenco Ticket" }}
        >
            <Row>
                <Col sm="12" className="mt-1">
                    <strong className="mt-2">Targa del veicolo</strong>
                    <InputGroup>
                        <Input
                            id="plateScanBox"
                            maxLength={15}
                            onKeyPress={onScanPlate}
                            invalid={errors.vehicle ? true : false}
                            valid={ticket.vehicle && !errors.vehicle ? true : false}
                        />
                        <InputGroupAddon addonType="append">
                            <Button
                                color="info"
                                onClick={getVehicle}
                            >
                                <FontAwesomeIcon icon={loading ? "circle-notch" : "search"}
                                    spin={loading} />
                            </Button>
                        </InputGroupAddon>
                        {errors.vehicle && (
                            <FormFeedback invalid="invalid">{errors.vehicle}</FormFeedback>
                        )}
                        {ticket.vehicle && !errors.vehicle && (
                            <FormFeedback valid="valid">
                                {`Targa: ${ticket.vehicle.plate} - Cliente: ${ticket.vehicle.customer_name}`}
                            </FormFeedback>
                        )}
                    </InputGroup>
                </Col>
                <Col sm="12" className="mt-4">
                    <strong className="mt-2">Codice Centrale Operativa</strong>
                    <InputGroup>
                        <Input
                            id="deviceScanBox"
                            placeholder="Inserire il codice della centrale operativa"
                            maxLength={20}
                            onKeyPress={onScanDevice}
                            invalid={errors.device ? true : false}
                            valid={ticket.device && !errors.device ? true : false}
                        />
                        <InputGroupAddon addonType="append">
                            <Button
                                color="info"
                                onClick={getDevice}
                            >
                                <FontAwesomeIcon icon={loading ? "circle-notch" : "search"}
                                    spin={loading} />
                            </Button>
                        </InputGroupAddon>
                        {errors.device && (
                            <FormFeedback invalid="invalid">{errors.device}</FormFeedback>
                        )}
                        {ticket.device && !errors.device && (
                            <FormFeedback valid="valid">
                                {`Cod. Centrale Operativa: ${ticket.device.ticket} - Cliente: ${ticket.device.customer_name}`}
                            </FormFeedback>
                        )}
                    </InputGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="mt-5">
                        <Button
                            className="float-left"
                            color="primary"
                            label="Torna"
                            onClick={() => {
                                history.go(-1);
                            }}
                        >
                            <FontAwesomeIcon icon="undo" /> Torna
                        </Button>
                        <div className="float-right">
                            <Button
                                className="mr-2"
                                color="secondary"
                                disabled={loading}
                                onClick={resetForm}
                            >
                                <FontAwesomeIcon icon="eraser" /> Pulisci
                            </Button>
                            <Button
                                className="mr-2"
                                disabled={loading}
                                color="danger"
                                onClick={plateLabel ? () => setOpenModal(plateLabel.toUpperCase()) : null}
                            >
                                <FontAwesomeIcon icon={loading ? "spinner" : "check"} /> Forza il Ticket
                            </Button>
                            <Button
                                disabled={loading || !isValid()}
                                color="success"
                                onClick={saveData}
                            >
                                <FontAwesomeIcon icon={loading ? "spinner" : "check"} /> Nuovo Ticket
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
            {modalSection()}
        </PageLayout>
    );
};

export default StartTicket;
